// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"aa8dd148","509":"d3d78c68","985":"69bcaff2"}[chunkId] + ".chunk.js";
};